<template>
  <div class="panel-group">
    <div class="panel-wrapper">
      <div class="panel-wrapper-header">
        <div class="panel-wrapper-header-tabs">
          <widgetTabs v-model="activeTab" :tabs="[
            {
              title: 'Drafts',
              value: 'drafts',
              icon: {
                inactive: require('@/assets/icons/draft-gray.svg'),
                active: require('@/assets/icons/draft-green.svg')
              }
            },
            {
              title: 'Sent Emails',
              value: 'sentEmails',
              icon: {
                inactive: require('@/assets/icons/sent-email-gray.svg'),
                active: require('@/assets/icons/sent-email-green.svg')
              }
            },
            {
              title: 'Signatures',
              value: 'signatures',
              icon: {
                inactive: require('@/assets/icons/signature-gray.svg'),
                active: require('@/assets/icons/signature-green.svg')
              }
            },
          ]" @change="switchTab"></widgetTabs>

        </div>
      </div>
      <div class="panel-wrapper-body">
        <div class="panel-wrapper-body-container">
          <div class="draft-email-item" v-for="(item, index) in draftEmail" :key="index" @click="selectItem(item)" :class="{
            active:
              selected_item_details && item.id === selected_item_details.id,
          }">
            <div class="draft-email-item-header">
              <div class="draft-email-item-header-icon">
                <img src="@/assets/icons/draft-white.svg" />
              </div>
              <div class="draft-email-item-header-title">{{ item.title }}</div>
            </div>
            <div class="draft-email-item-body">
              <div class="draft-email-item-body-text">
                {{ htmlToText(item.description) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="email-draft-preview">
      <!-- Tab content details for email -->
      <div class="tab-content-details" v-if="selected_item_details">
        <div class="tab-content-details-header">
          <div class="tab-content-details-header-left-panel">
            <div class="tab-content-details-title">
              {{ selected_item_details.title }}
            </div>
            <div class="tab-content-details-date">
              {{ selected_item_details.created_at | formatDate }}
            </div>
          </div>
          <div class="tab-content-details-options row">
            <widgetButton @click="updateEmail(selected_item_details)" class="btn-secondary">
              Send
            </widgetButton>
            <div class="h-spacer"></div>
            <dropdown-menu>
              <ul>
                <li>
                  <a @click="updateEmail(selected_item_details)">Update Email
                  </a>
                </li>
                <li>
                  <app-dialog title="Delete Email" ask="Are you sure you want to delete this email?" yesText="Delete"
                    noText="Cancel" @onComfirm="deleteEmail(selected_item_details)">
                    <a>Delete Email</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>
        <div class="tab-content-details-body" v-html="selected_item_details.description"></div>
      </div>

      <!-- When no item selected -->
      <div class="widget-notfound" v-if="!selected_item_details">
        <widgetNotFoundWidget title="No email draft selected" content="Select email draft to view its details"
          align="center">
          <img class="widget-img" src="@/assets/icons/select-item.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>
  </div>
</template>
  
<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      selected_item_details: null,
      draftEmail: [],
      loading_page_data: false,
      activeTab: 1
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("draftEmailReflesh", () => {
      vm.getEmailDraft();
    });
    vm.getEmailDraft();
  },
  computed: {},
  watch: {},
  methods: {
    switchTab(tab) {
      let vm = this;
      if (tab.value == "drafts") {
        vm.activeTab = 1;
      } else if (tab.value == "outbox") {
        vm.activeTab = 2;
      } else if (tab.value == "signatures") {
        vm.activeTab = 3;
      }
      vm.$emit("switchTab", vm.activeTab);
    },
    updateEmail(item) {
      let vm = this;
      vm.$emit("updateEmail", item);
    },
    selectItem(item) {
      let vm = this;
      vm.selected_item_details = item;
    },
    deleteEmail(item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_DELETE", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getEmailDraft();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Email is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something wrong while deleting email",
            type: "warn",
            duration: 3000,
          });
        });
    },
    getEmailDraft() {
      let vm = this;
      vm.loading_page_data = true;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_GET_ALL", {
          phase: vm.phase,
        })
        .then((responce) => {
          vm.loading_page_data = false;
          vm.draftEmail = responce.data.map((item) => {
            eventBus.$set(item, "editing", false);
            eventBus.$set(item, "loading", false);
            return item;
          });
        })
        .catch((error) => {
          vm.loading_page_data = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-group {
  width: calc(100% - 330px);
  display: flex;
  height: 100%;

  .panel-wrapper {
    width: 320px;
    height: 100%;

    .panel-wrapper-header {
      height: 50px;
      background: #ffffff;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;

      .panel-wrapper-header-tabs {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        width: 100%;

        .tabs-widget {
          display: flex;
          width: 100%;

          .tabs-item {
            display: flex;
            align-items: center;
            margin-right: 20px;
            cursor: pointer;

            .tabs-item-icon {
              margin-right: 5px;
              display: flex;
              align-items: center;
              height: 100%;

              img {
                width: 14px;
              }

              .active-icon {
                display: none;
              }
            }

            .tabs-item-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              color: #707070;
            }

            &.active,
            &:hover {
              .tabs-item-title {
                color: #1ba5a4;
              }

              .tabs-item-icon {
                .inactive-icon {
                  display: none;
                }

                .active-icon {
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .panel-wrapper-body {
      height: calc(100% - 50px);
      overflow-y: auto;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;

      .panel-wrapper-body-container {
        background: #ffffff;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        padding-bottom: 10px;

        .draft-email-item {
          padding: 10px 10px;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f4f4f4;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
            transition: 0.1s ease-in-out;
          }

          &.active {
            background: #f4f4f4;
            transition: 0.1s ease-in-out;
          }

          .draft-email-item-header {
            display: flex;
            align-items: center;
            margin-bottom: 7px;

            .draft-email-item-header-icon {
              margin-right: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 22px;
              width: 22px;
              background: #1ba5a4;
              border-radius: 5px;

              img {
                width: 12px;
              }
            }

            .draft-email-item-header-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 19px;
              color: #1c1c1c;
            }
          }

          .draft-email-item-body {
            .draft-email-item-body-text {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 11px;
              color: #8e8b8b;
              overflow: hidden;
              display: block;
              max-height: 4rem;
              -webkit-line-clamp: 2;
              display: box;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: normal;
            }
          }
        }
      }
    }
  }

  .email-draft-preview {
    width: calc(100% - 320px);
    height: 100%;
    border-radius: 7px;
    margin-left: 5px;

    .tab-content-details {
      width: 100%;
      height: max-content;
      border-radius: 5px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      padding: 0px 15px;
      padding-bottom: 80px;

      .tab-content-details-header {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tab-content-details-header-left-panel {
          .tab-content-details-title {
            font-size: 20px;
          }

          .tab-content-details-date {
            color: #707070;
          }
        }

        .tab-content-details-options {
          display: flex;
          align-items: center;
        }
      }

      .tab-content-details-body {
        padding: 15px;
        background: #fafafa;
        border-radius: 10px;

        .emaill-subject {
          font-size: 18px;
          margin-bottom: 20px;
        }

        p {
          margin: 0px;
          margin-bottom: 3px;
        }
      }
    }

    .widget-notfound {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #ffffff;
    }
  }
}
</style>

  

  